import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf88edb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "tag-floating tag-copied fadeout animation-duration-3000 animation-iteration-1"
}
const _hoisted_3 = {
  key: 1,
  class: "tag-floating tag-copy"
}

import { ref, computed } from 'vue';
import { UniqueComponentId } from 'primevue/utils';
import Icon from '@/components/icon/Icon';
import { useI18n } from 'vue-i18n';
import { useNotifications } from '@/store/modules/notifications/useNotifications';


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyIcon',
  props: {
    data: null,
    color: null
  },
  setup(__props: any) {

const props = __props as {
  data?: string;
  color?: string;
}



const { t } = useI18n();
const buttonId = UniqueComponentId();
const isTouch = computed(() => 'ontouchstart' in window || navigator.maxTouchPoints);
const { addNotification } = useNotifications();
const isCopied = ref(false);
const tagHide = () => (isCopied.value = false);

const successCopyToClipboard = () => {
  isCopied.value = true;
  setTimeout(tagHide, 3500);
};

const fallback = () => {
  if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    const input = document.createElement('input');
    input.style.position = 'absolute';
    input.style.right = '9999px';
    input.setAttribute('readonly', 'true');
    document.getElementById(buttonId)!.appendChild(input);
    input.value = props.data as string;
    input.focus();
    input.select();
    try {
      successCopyToClipboard();
      return document.execCommand('copy');
    } catch (ex) {
      addNotification({
        id: 'common',
        status: 'error',
        content: `${t('error.copyFailed')} ${ex}`,
      });
    } finally {
      document.getElementById(buttonId)!.removeChild(input);
    }
  }
};
const copyToClipboard = () => {
  if(!props.data) return;
  if (!navigator.clipboard) {
    fallback();
    return;
  }
  navigator.clipboard
    .writeText(props.data)
    .then(() => {
      successCopyToClipboard();
    })
    .catch(() => {
      fallback();
    });
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    id: _unref(buttonId),
    class: "copy-button-wrapper"
  }, [
    _createVNode(_component_Button, {
      class: _normalizeClass(["button-copy", [__props.color ? `text-${__props.color}` : '', { hoverable: !isCopied.value }]]),
      onClick: copyToClipboard
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Icon), {
          name: "copy",
          size: "20"
        })
      ]),
      _: 1
    }, 8, ["class"]),
    (isCopied.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Copied "))
      : _createCommentVNode("", true),
    (!_unref(isTouch))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Copy"))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})